Namespace 'Customer.Filters.Ticket'

class Customer.Filters.Ticket.AppointmentsFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/ticket/appointments_filter']
  className: 'checkboxes filter-field-container appointments-filter mw-100 d-flex'

  initialize: ({filter}) ->
    @filter = filter

  render: ->
    @$el.html @template
    @_initializeAppointments()
    @

  _initializeAppointments: ->
    appointments = @filter.get('query').appointments
    if appointments
      @$el.find("##{appointments}")[0].checked = true
    else
      @$el.find('#indistinct')[0].checked = true

  getAppointments: ->
    @$el.find('.appointments input[type=radio]:checked')[0].id
